export const userUpdatesAddonsEvent = (
  availableAddons,
  previousAddons,
  newAddons,
) => ({
  type: 'User updates add-ons',
  data: {
    availableAddons: availableAddons.map(({ value }) => value),
    previousAddons,
    newAddons,
  },
});

export const userExpandsAddonDetailsEvent = ({ value }) => ({
  type: 'User expands add-on details',
  data: {
    addon: value,
  },
});

export const userViewsAddOnForm = ({ availableAddons, unavailableAddons }) => ({
  type: 'View add-ons form',
  data: {
    availableAddons,
    unavailableAddons,
  },
});
